import { MetricIdEnum, ILineChartConfig } from './Metrics.model';

export const LINE_CHART_CONFIGS: Partial<Record<MetricIdEnum, ILineChartConfig>> = {
  [MetricIdEnum.timeBasedUtilization]: {
    yAxisLabel: '% hours utilization',
    yAxisDomain: [0, 100],
    xAxisLabel: 'Date',
    tooltipLabel: 'Utilization',
    emptyStateMessage: 'No utilization data available for this period',
  },
};

